import { prefix } from './actions';

export const loading = state => state[prefix].loading;
export const processing = state => state[prefix].processing;
export const globalSettings = state => state[prefix].globalSettings;
export const showRelated = state => state[prefix].globalSettings.showRelated;
